import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { url } from '../../../utils/variables';
import { uploadImages } from '../../../utils/functions';
import ImagePickerModal from '../../master/ImagePickerModal';
import Modal from '../../master/Modal';
import culImage from '../../../assets/images/new-cul.png'
import losImage from '../../../assets/images/new-loss.png';

import ImageZoom from '../../master/ImageZoom';
import { useTranslation } from 'react-i18next';

export default function ReportImages({ report }) {

    const { t } = useTranslation();

    const { user } = useSelector((store) => store);

    const [attachments, setAttachments] = useState([]);
    const [imgUid, setImgUid] = useState(null);
    const [step,setStep] = useState(0)

    useEffect(() => {
        if (!report.id) return;
        setAttachments([...report.attachments, ...report.accident.attachments]);
    }, [report]);
    // const images = [
    //     ...attachments.filter(img=>img.filename.includes('culprit')),
    //     ...attachments.filter(img => img.filename.includes('cul_crash_image')),
    //     ...attachments.filter(img=>(img.filename.includes('losses') && img.filename.includes(`${report.losses_index}`))),
    //     ...attachments.filter(img => img.filename.includes(`los_crash_image_x${report.losses_index}x_`)),
    //     ...attachments.filter(img => img.filename.includes('expert_crash_image_cul')),
    //     ...attachments.filter(img => img.filename.includes(`expert_crash_image_los_x${report.losses_index}x_`)),
    //     ...attachments.filter(img=>img.filename.includes('damage_image'))
    // ]
    const culpritImage = [
        ...attachments.filter(img=>img.filename.includes('cul')),
        ...attachments.filter(img=>img.filename.includes('damage_image'))
    ]
    const lossesImage = [
        ...attachments.filter(img=>(img.filename.includes('los') && img.filename.includes(`${report.losses_index}`)))
    ]
    const allImages = [
        {key: t('Coroukie image') , value: 'coroukie_image'},
        {key: t('Crash image') ,value: 'crash_image'},
        {key: t('Damage image'), value: 'damage_image'},
        {key: t('License'), value:'license_image'},
        {key: t('License back'),value:'license_back_image'},
        {key: t('Vehicle card'), value: 'vehicle_card_image'},
        {key: t('Vehicle card back'), value: 'vehicle_card_back_image'},
        {key: t('Third insurance'), value: 'third_image'},
        {key: t('Body insurance'), value: 'body_image'},
        {key: t('Front vehicle'), value: 'front_image'},
        {key: t('Back vehicle'), value: 'back_image'},
        {key: t('Left side vehicle'), value: 'left_image'},
        {key: t('Right side vehicle'), value: 'right_image'},
        {key: t('Chassis number'), value: 'chassis_number'},
        // {key : 'تصویر تکمیلی',value: 'extra'}
    ];
    function finishUpload(image,type, done) {
        const { accident } = report;
        // let extraImages = attachments.filter(itm => (
        //     itm.filename.includes(`${user.type === 'expert' ? 'expert_' : ''}crash_image`)
        // ));
        // if (user.type === 'user') {
        //     extraImages = extraImages.filter(itm => (
        //         !itm.filename.includes('expert')
        //     ));
        // }
        
        let name 
        if(user.type === 'expert'){
            name = type === 'cul'? `expert_crash_image_cul${attachments.filter(img => img.filename.includes('expert_crash_image_cul')).length + 1}` 
            : `expert_crash_image_los_x${report.losses_index}x_${attachments.filter(img => img.filename.includes(`expert_crash_image_los_x${report.losses_index}x_`)).length + 1}`
        }else {
            name = type === 'cul'? `cul_crash_image${attachments.filter(img => img.filename.includes('cul_crash_image')).length + 1}`
            : `los_crash_image_x${report.losses_index}x_${attachments.filter(img => img.filename.includes(`los_crash_image_x${report.losses_index}x_`)).length + 1}`
        }
        //const extraImagesCount = extraImages.length + 1;
        uploadImages({
            id: accident.id,
            type: 'accident',
            //name: `${user.type === 'expert' ? name : `crash_image${extraImagesCount}`}`,
            name :name,
            image,
            done,
            callback: (data) => {
                setAttachments(prevState => ([
                    ...prevState,
                    data,
                ]));
            },
        });
    }

    return (
        <>
        <p className='title'>{t('File image')}</p>
        <div className='box images'>
            <Modal visible={imgUid}>
                <div className='image-modal'>
                    <i className='fas fa-times'
                       onClick={() => setImgUid(null)}
                    />
                    <ImageZoom imgUid={imgUid}/>
                </div>
            </Modal>
            <div className='d-flex'>
                <p className={`image-title b-bl-sharp ${step === 0 ? 'active' :''}`} onClick={()=>setStep(0)}>مدارک {t('Culprit')}</p>
                {report.losses && <p className={`image-title b-br-sharp ${step === 1 ? 'active' :''}`} onClick={()=>setStep(1)}>مدارک {t('Losses')}</p>}
            </div>
            <div className='imageBox'>
                {/* {
                    images.map(img => (
                        <div className='imageParent' key={img.uid}>
                            <img
                                onClick={() => setImgUid(img.uid)}
                                src={`${url}/files?uid=${img.uid}&width=200&height=200`}
                                alt='img'
                            />
                        </div>
                    ))
                } */}
                {step === 0 &&culpritImage.map(img=>(
                        <div className='imageParent register-image-parent' key={img.id}>
                            <p className='image-label'>
                                {allImages[allImages.findIndex((itm)=> img.filename.includes(itm.value))]?.key ||t('Completment image')}
                            </p>
                            <img
                                onClick={() => setImgUid(img.uid)}
                                src={`${url}/files?uid=${img.uid}&width=200&height=200`}
                                alt='img'
                                id={img.id}
                            />
                        </div>
                    ))}
                {step === 0 &&
                <div className='imageParent register-image-parent'>
                    <p className='image-label'>
                        {t('Completment image')}
                    </p>
                    <ImagePickerModal
                        renderBtn={
                            'default'
                        // <div style={{position:'relative'}}><img src={culImage} alt='img' style={{height : '100px'}}/><i className={`defaultImg`} style={{color: '#00678d'}}>{t('Culprit')}</i></div>
                        }
                        label='complement_img'
                        upload={(image, done) => finishUpload(image,'cul', done)}
                    />
                </div>
                }
                {step === 1 && report.losses_index && 
                <>
                 {lossesImage.map(img=>(
                         <div className='imageParent register-image-parent' key={img.id}>
                            <p className='image-label'>
                                {allImages[allImages.findIndex((itm)=> img.filename.includes(itm.value))]?.key || t('Completment image')}
                             </p>
                             <img
                                 onClick={() => setImgUid(img.uid)}
                                 src={`${url}/files?uid=${img.uid}&width=200&height=200`}
                                 alt='img'
                             />
                         </div>
                     ))}
                <div className='imageParent register-image-parent'>
                    <p className='image-label'>
                        {t('Completment image')}
                    </p>
                    <ImagePickerModal
                        renderBtn={'default'
                        // <div style={{position:'relative'}}><img src={losImage} alt='img' style={{height : '100px'}}/><i className='defaultImg' style={{color:'#8d4600'}}>{t('Losses')}</i></div>
                        }
                        label='complement_img'
                        upload={(image, done) => finishUpload(image,'los', done)}
                    />
                </div>
                </>
}
            </div>
        </div>
        </>
    );
}
